'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WorkflowFileUploader(props) {
    var initialFiles = (0, _metrixCommon.getElementValueByCode)(props.return && props.return.elements, 'InitialFiles') || []; //NOSONAR
    var config = (0, _metrixCommon.getElementValueByCode)(props.component && props.component.elements, 'config'); //NOSONAR

    (0, _react.useEffect)(function () {
        handleSetReturn();
    }, []);

    var handleSetReturn = function handleSetReturn() {
        props.doSetReturn({ componentCode: props.component.code, code: 'InitialFiles', value: initialFiles });
    };

    return _react2.default.createElement(_metrixCommon.FileUploader, {
        session: props.context.session,
        config: config,
        initialFiles: initialFiles,
        onUploadComplete: handleSetReturn,
        onFileDelete: handleSetReturn
    });
}

exports.default = WorkflowFileUploader;